<ng-container *transloco="let t;">
    <div class="container-fluid">
 
        <div class="row">
            <div class="col-12 col-lg-12 col-md-12 p-2 pb-1">
                <h3 class="title-heading-text mt-1 mb-50">{{ t('Import preview header (upload files preview step) - Preview import data') }}</h3>
                <p class="mb-0">{{t('Step title description (upload files preview step) - You can see preview of Your import')}}.</p>
            </div>
        </div>

        <div class="row g-0 pb-2">
            <div class="col-12 col-lg-12 col-md-12 p-0">
                <div class="minHeightForTable table-height overflow-auto pt-1">
                    <app-table
                            [columns]="columns"
                            [data]="previewData"
                            [emptyDataTemplate]="nothingToImport"
                            [rowDetailsTemplate]="previewDetailsRow"
                    ></app-table>
                    <ng-template #previewDetailsRow let-rowData="rowData">
                        @if(hasWarningsOrErrors(rowData?.warnings)) {
                            <tr>
                                <td [colSpan]="columns?.length ?? 1">
                                    <div class="text-warning">
                                        <ul>
                                            @for (warning of rowData.warnings | keyvalue ; track warning.key){
                                                @for (message of warning.value; track message) {
                                                    <li>{{ message }}</li>
                                                }
                                            }
                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        }
                    </ng-template>
                    <ng-template #nothingToImport>
                        {{ t('Nothing to import notification description (upload files preview step) - There is nothing to import') }}
                    </ng-template>
                    
                </div>
                <div class="row m-0 merge-data-radio ps-2 pe-2 pb-0 w-100">
                    <div class="col-12 d-flex justify-content-between align-items-baseline mt-1">
                        <div>
                            <b>{{statistics?.valid_count ?? 0}}</b> {{ t('Valid for import rows count text (upload files preview step) - valid data can be imported') }}
                        </div>
                        <div>
                            <ng-container *ngIf="!isImported; else nextBtn">
                                <button type="button" class="btn btn-success" rippleEffect (click)="importXLS()" [disabled]="isImporting">
                                    <span *ngIf="isImporting" class="spinner-border spinner-border-sm me-1"></span>
                                    {{ t('Import button (bulk upload) - Import') }}
                                </button>
                            </ng-container>
                            <ng-template #nextBtn>
                                <button type="button" class="btn btn-success" rippleEffect (click)="goToNextFromPreview()">
                                    {{ t('Next button (bulk upload) - Next') }}
                                </button>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        @if(invalidData.length > 0) {
            <div class="row g-0 pb-2">
                <div class="col-12 col-lg-12 col-md-12 p-0">
                    <div class="minHeightForTable table-height overflow-auto pt-1">
                        <app-table
                                [columns]="columns"
                                [data]="invalidData"
                                [emptyDataTemplate]="nothingToImport"
                                [rowDetailsTemplate]="invalidDetailsRow"
                        ></app-table>
                        <ng-template #invalidDetailsRow let-rowData="rowData">
                            @if (hasWarningsOrErrors(rowData?.warnings) || hasWarningsOrErrors(rowData?.errors)) {
                                <tr>
                                    <td [colSpan]="columns?.length ?? 1">
                                        @if (hasWarningsOrErrors(rowData?.warnings)) {
                                            <div class="text-warning">
                                                <ul>
                                                    @for (warning of rowData.warnings | keyvalue; track warning.key) {
                                                        @for (message of warning.value; track message) {
                                                            <li>{{ message }}</li>
                                                        }
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        @if (hasWarningsOrErrors(rowData?.errors)) {
                                            <div class="text-danger">
                                                <ul>
                                                    @for (error of rowData.errors | keyvalue; track error.key) {
                                                        @for (message of error.value; track message) {
                                                            <li>{{ message }}</li>
                                                        }
                                                    }
                                                </ul>
                                            </div>
                                        }
                                    </td>
                                </tr>
                            }
                        </ng-template>
                        <ng-template #nothingToImport>
                            {{ t('Nothing to import notification description (upload files preview step) - There is nothing to import') }}
                        </ng-template>
                    </div>
                    <div class="row m-0 merge-data-radio ps-2 pe-2 pb-0 w-100">
                        <div class="col-12 d-flex justify-content-between align-items-baseline mt-1">
                            <div>
                                <b>{{statistics?.invalid_count ?? 0}}</b> {{ t('Invalid import rows count text (upload files preview step) - invalid data') }}
                            </div>
                            <div>
                                <button type="button" class="btn btn-success" rippleEffect (click)="exportFailedData()">
                                    {{ t('Export button text (upload files preview step) - export') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
</ng-container>